// removed by extract-text-webpack-plugin
module.exports = {"MainContainer":"MainContainer","sideMenuHidden":"sideMenuHidden","noSideMenu":"noSideMenu","Content":"Content","upgrade-plan":"upgrade-plan","LoginPageWrapper":"LoginPageWrapper","searchOverlay":"searchOverlay","locale-CN":"locale-CN"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Main/Main.scss
// module id = ZxDm
// module chunks = 0